var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPellSocialX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9014 0.152527H22.5816L14.5416 9.3424L24 21.8474H16.5938L10.7934 14.2631L4.15641 21.8474H0.473906L9.07312 12.0182L0 0.152527H7.59375L12.8372 7.08477L18.9014 0.152527ZM17.6095 19.6442H19.6491L6.48563 2.23998H4.2975L17.6095 19.6447V19.6442Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPellSocialX);
export default __webpack_public_path__ + "static/media/pell_social_x.9d3b1647cd8d2d9f58101e45eddf93d4.svg";
export { ForwardRef as ReactComponent };